<template>
  <v-container>
    <v-row row wrap>
      <v-col class="col-12">
        <label>Should we email alerts to you?</label>
      </v-col>
      <v-col class="col-12">
        <v-btn v-bind:text="!value" @click="setSendEmail(true)">
          <v-icon v-if="value">check</v-icon>
          Yes
        </v-btn>
        <v-btn v-bind:text="value" @click="setSendEmail(false)">
          <v-icon v-if="!value">check</v-icon>
          No Thanks
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
const EMITTED_ACTIONS = {
  INPUT: "input",
};
export default {
  name: "SendEmailEditor",
  props: {
    value: {
      type: Boolean,
      required: true,
      default: true,
    },
  },
  data() {
    return {
      sendEmail: null,
    };
  },
  methods: {
    setSendEmail(value) {
      this.sendEmail = value;
    },
  },
  watch: {
    sendEmail() {
      this.$emit(EMITTED_ACTIONS.INPUT, this.sendEmail);
    },
  },
};
</script>
<style scoped></style>
